import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import useUniformConfigurationSelector from '../../../../../../hooks/useUniformConfigurationSelector';

const propTypes = {
  contactLabel: PropTypes.string,
  uniformConfiguration: PropTypes.shape({
    id: PropTypes.string,
    album_folder_tag_id: PropTypes.string,
    uniform_album_folder_tag_level_id: PropTypes.string,
    uniform_album_folder_tag_team_id: PropTypes.string,
    label: PropTypes.string,
  }),
  setUniformConfiguration: PropTypes.func,
};
const UniformConfigurationSelector = ({
  contactLabel,
  uniformConfiguration,
  setUniformConfiguration,
}) => {
  const { albumFolder, selectorOptions } = useUniformConfigurationSelector({});

  // Disable this component for now. The new upload system makes this unnecessary.
  if (!albumFolder || selectorOptions.length === 0 || true) {
    return null;
  }

  return (
    <div className="mt-1 mb-2">
      <h4 className="mb-0">
        If uploading a roster with numbered jerseys, select a sport and level:
      </h4>
      <hr className="w-100 my-1" />
      <p>
        Please provide team, sport, level, and a jersey number for each{' '}
        {contactLabel}
      </p>
      <div className="text-left">
        <Select
          id="uniform-tag-configuration"
          options={selectorOptions}
          placeholder="Search uniform configuration..."
          label="Select the tag, level, and team configuration"
          value={uniformConfiguration}
          getOptionValue={item => item.id}
          filterOption={(option, searchText) => {
            if (
              option.label
                .toLowerCase()
                .includes((searchText ?? '').toLowerCase())
            ) {
              return true;
            }
            return false;
          }}
          onChange={selectedOption => {
            if (selectedOption) {
              setUniformConfiguration(selectedOption);
            } else {
              setUniformConfiguration(undefined);
            }
          }}
          cacheOptions
          isClearable
        />
      </div>
    </div>
  );
};

UniformConfigurationSelector.propTypes = propTypes;

export default UniformConfigurationSelector;
